import Component from '../core/Component';
import EventBus from '../core/EventBus'
import { queries, CMS } from '../core/config'
import Scroll, { scrollToElement } from '../services/Scroll'
import enquire from 'enquire.js'
import ScrollContainer from './ScrollContainer'

export const STATES = {
    READY: 'is-ready',
    ACTIVE: 'is-active'
}

export default class Tabs extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            links: [],
            items: [],
            viewport: null,
            indicator: null,
            navigation: null,
            prev: null,
            next: null
        }

        this.enquireHandler = {
            match: () => this.match(),
            unmatch: () => this.unmatch()
        }

        this.hasNavigation = true
        this.isMobile = false
        this.isPrepared = false
        this.currIndex = 0
    }

    prepare() {
        if (CMS) {
            return
        }

        if (this.ref.prev && this.ref.next) {
            this.ref.prev.addEventListener('click', this.handleArrowClick)
            this.ref.next.addEventListener('click', this.handleArrowClick)
        }

        enquire.register(queries.mediumMax, this.enquireHandler)
        Scroll.on('resize', this.handleResize)

        this.initSlider()
        this.element.classList.add(STATES.READY)
    }

    destroy() {
        enquire.unregister(queries.mediumMax, this.enquireHandler)
        Scroll.off('resize', this.handleResize)
    }

    match = () => {
        this.isMobile = true

        if (this.ref.navigation) {
            this.navigation = new ScrollContainer(this.ref.navigation)
            this.navigation.prepare()
        }
    }

    unmatch = () => {
        this.isMobile = false

        if (this.navigation) {
            this.navigation.destroy()
        }
    }

    reset() {
        this.ref.items.map(($element, index) => {
            if ($element.classList.contains(STATES.ACTIVE)) {
                this.currIndex = index
                $element.classList.remove(STATES.ACTIVE)
            }
        })
    }

    initSlider() {
        if (this.ref.links[0]) {
            this.ref.links.map(($element, index) => {
                $element.addEventListener('click', event => {
                    this.handleNavigationClick(event, index)
                })

                if ($element.classList.contains(STATES.ACTIVE)) {
                    this.currIndex = index
                    this.moveIndicator($element)
                }
            })

            this.hasNavigation = true
        } else {
            this.ref.items.map(($element, index) => {
                if ($element.classList.contains(STATES.ACTIVE)) {
                    this.currIndex = index
                }
            })

            this.hasNavigation = false
        }

        this.handleResize()
        EventBus.on('modal:open', this.handleModalOpen)
        EventBus.on('tab:selected', this.selectItem)
        EventBus.emit('window:resized')
    }

    handleModalOpen = modal => {
        if (modal.id == "career-modal") {
            this.modalSlider = Component.getFromElement("tabs")

            if (this.modalSlider) {
                this.modalSlider.reset()
                this.modalSlider.selectItem(this.currIndex)
                this.modalSlider.handleResize()
            }
        }
    }

    handleNavigationClick = (event, index) => {
        event.preventDefault()

        if (index == this.currIndex) {
            return
        }

        let isLeft = (index < this.currIndex) ? true : false

        this.ref.links[this.currIndex].classList.remove(STATES.ACTIVE)
        this.ref.links[index].classList.add(STATES.ACTIVE)

        scrollToElement(this.element, {
            mode: 'auto'
        })

        this.moveIndicator(event.target)
        this.setDirection(isLeft)
        this.selectItem(index)
    }

    handleArrowClick = event => {
        event.preventDefault()

        let index = parseInt(this.currIndex)
        let isLeft = (event.target.closest('button').classList.contains('ControlBlock--arrowLeft')) ? true : false

        if (isLeft) {
            index = this.currIndex - 1

            if (index < 0) {
                index = this.ref.items.length-1
            }
        } else {
            index = this.currIndex + 1

            if (index > this.ref.items.length-1) {
                index = 0
            }
        }

        this.setDirection(isLeft)
        this.selectItem(index)
    }

    handleResize = () => {
        this.ref.items.map($element => {
            let boxes = Array.from($element.querySelectorAll('.career-About-box'))

            boxes.map($box => {
                this.prepareBox($box)
            })

            if ($element.classList.contains(STATES.ACTIVE)) {
                this.resize(boxes)
            }
        })

        if (this.currIndex && this.ref.links[0]) {
            this.moveIndicator(this.ref.links[this.currIndex])
        }
    }

    setDirection(isLeft) {
        if (isLeft) {
            this.element.classList.remove('to-right')
            this.element.classList.add('to-left')
        } else {
            this.element.classList.remove('to-left')
            this.element.classList.add('to-right')
        }
    }

    prepareBox($box) {
        let $boxInner = $box.querySelector('.tab-visual-holder')

        if (this.isMobile) {
            $boxInner.style.width = ''
        } else {
            $boxInner.style.width = $box.getBoundingClientRect().width + 'px'
        }
    }

    selectItem(index) {
        let boxes = Array.from(this.ref.items[index].querySelectorAll('.career-About-box'))
        this.resize(boxes)

        this.ref.items[this.currIndex].classList.remove(STATES.ACTIVE)
        this.ref.items[index].classList.add(STATES.ACTIVE)
        this.currIndex = index
    }

    resize(boxes) {
        let top = 100000
        let bottom = 0
        let windowTop = Scroll.getScroll().y

        boxes.map(($box, index) => {
            let $innerBox = $box.querySelector('.tab-visual-holder')

            if ($innerBox.getBoundingClientRect().top + windowTop < top && $innerBox.getBoundingClientRect().top != 0) {
                top = $innerBox.getBoundingClientRect().top + windowTop
            }

            if ($innerBox.getBoundingClientRect().bottom + windowTop > bottom && $innerBox.getBoundingClientRect().bottom != 0) {
                bottom = $innerBox.getBoundingClientRect().bottom + windowTop
            }
        })

        let height = bottom - top
        this.ref.viewport.style.height = height + 'px'
    }

    moveIndicator($link) {
        this.ref.indicator.style.width = $link.getBoundingClientRect().width + 'px'

        if (this.isMobile) {
            this.ref.indicator.style.left = $link.getBoundingClientRect().left - this.ref.navigation.querySelector('.scroll-content').getBoundingClientRect().left + 'px'
        } else {
            this.ref.indicator.style.left = $link.getBoundingClientRect().left - this.ref.navigation.getBoundingClientRect().left + 'px'
        }
    }
}